export interface ChatSuggestion {
  label: string;
  kind?: "deepen" | "explore" | "practice" | string;
}

const FENCE_RE = /```suggestions\s*\n([\s\S]*?)\n```/i;

/**
 * Extract the trailing ```suggestions``` JSON block (if any) from an
 * assistant message and return both the parsed list and the cleaned
 * message text (with the block removed).
 */
export function parseSuggestionsBlock(message: string): {
  cleaned: string;
  suggestions: ChatSuggestion[];
} {
  if (!message) return { cleaned: message, suggestions: [] };
  const match = message.match(FENCE_RE);
  if (!match) return { cleaned: message, suggestions: [] };
  const cleaned = message.replace(FENCE_RE, "").trimEnd();
  try {
    const raw = JSON.parse(match[1]);
    if (!Array.isArray(raw)) return { cleaned, suggestions: [] };
    const suggestions: ChatSuggestion[] = raw
      .map((s: any): ChatSuggestion | null => {
        if (typeof s === "string") return { label: s };
        if (s && typeof s.label === "string") return { label: s.label, kind: s.kind };
        return null;
      })
      .filter((x: ChatSuggestion | null): x is ChatSuggestion => !!x && x.label.trim().length > 0)
      .slice(0, 4);
    return { cleaned, suggestions };
  } catch {
    return { cleaned, suggestions: [] };
  }
}
